import { useParams } from "react-router-dom";

import { IZone } from "interfaces/zone.interface";

import { SubjectCreateForm } from "./forms/SubjectCreateForm";

type SubjectCreatePageProps = {
  zones: IZone[];
};

export function SubjectCreatePage({ zones }: SubjectCreatePageProps) {
  const { zoneId } = useParams<{ zoneId: string }>();

  if (!zoneId) {
    throw new Error("No zone in URL");
  }

  return <SubjectCreateForm key={zoneId} zoneId={zoneId} zones={zones} />;
}
